import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { useApiSDK } from '../../contexts/apiSdkContext';
import { AppContext } from '../../contexts/app-context';

type TSceneDeleteHook = {
  isError: boolean;
  isLoading: boolean;
  mutate: UseMutationResult<void, unknown, string, unknown>['mutate'];
};

function useDeleteScene(): TSceneDeleteHook {
  const sdk = useApiSDK();
  const appContext = useContext(AppContext);
  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const { isError, isLoading, mutate } = useMutation({
    mutationFn: (id: string) => sdk.scenes.delete(id),
    onSuccess: async () => {
      await queryClient.invalidateQueries(['scenes']);
      await queryClient.invalidateQueries(['scene']);
      appContext?.crudAlert('delete', 'scene', 'f');
      navigate('/scenes');
    },
    onError: async (error: any) => {
      if (error) {
        const responseErrors = error.response.data.errors;
        responseErrors.forEach((err: { message: string; description: string }) => {
          appContext?.systemAlert('error', err.description);
        });
      }
    },
  });

  return { isError, isLoading, mutate };
}

export { useDeleteScene };
